import React                    from 'react';

const Logo = () => {
    return (
        <div className="application-header-logo">
        </div>
    )
}

export default Logo;